<div class="flex items-center">
  <span class="header-name">
    {{ headerName }}
  </span>
  @if (filterActive) {
  <mat-icon
    class="text-lg h-xxs text-blue ml-bl-1 filter-active-indicator"
    [attr.data-pgr-id]="headerName + ' Grid Indicator'"
  >
    fiber_manual_record
  </mat-icon>
  } @if (filterActive) {
  <span class="screen-reader-only" role="alert">
    {{ headerName }} filtered
  </span>
  }
</div>
